import React from "react";

const updatedDate = "May 10, 2026";

const styles = {
    page: {
        minHeight: "100vh",
        background:
            "radial-gradient(circle at top left, rgba(197,155,69,0.12), transparent 32%), radial-gradient(circle at top right, rgba(5,7,19,0.10), transparent 30%), linear-gradient(to bottom, #F7F8FA, #F2F3F5 45%, #F7F8FA)",
        color: "#0F172A",
        padding: "72px 20px",
        fontFamily:
            "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
    },
    container: {
        maxWidth: "1040px",
        margin: "0 auto",
        lineHeight: 1.75,
    },
    badge: {
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 12px",
        borderRadius: "999px",
        background: "#FFF9EA",
        color: "#7A5A17",
        border: "1px solid #E7D8AC",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        marginBottom: "18px",
    },
    h1: {
        fontSize: "clamp(32px, 4vw, 48px)",
        lineHeight: 1.08,
        margin: "0 0 14px",
        letterSpacing: "-0.04em",
        color: "#050713",
        fontWeight: 700,
    },
    updated: {
        color: "#64748B",
        marginBottom: "34px",
        fontSize: "14px",
    },
    h2: {
        fontSize: "18px",
        marginTop: "30px",
        marginBottom: "10px",
        color: "#050713",
        letterSpacing: "-0.015em",
        fontWeight: 700,
    },
    p: {
        color: "#475569",
        margin: "0 0 14px",
        fontSize: "15px",
    },
    ul: {
        color: "#475569",
        paddingLeft: "22px",
        marginTop: "8px",
        fontSize: "15px",
    },
    box: {
        border: "1px solid #E2E8F0",
        background: "#FFFFFF",
        borderRadius: "24px",
        padding: "24px",
        margin: "24px 0 32px",
        boxShadow: "0 18px 55px rgba(15, 23, 42, 0.06)",
    },
    document: {
        border: "1px solid #E2E8F0",
        background: "#FFFFFF",
        borderRadius: "30px",
        padding: "32px",
        boxShadow: "0 18px 55px rgba(15, 23, 42, 0.06)",
    },
    link: {
        color: "#7A5A17",
        textDecoration: "none",
        fontWeight: 700,
    },
};

export default function Contact() {
    return (
        <main style={styles.page}>
            <section style={styles.container}>
                <div style={styles.badge}>Krionex Support</div>

                <h1 style={styles.h1}>Contact Us</h1>
                <p style={styles.updated}>Last updated: {updatedDate}</p>

                <div style={styles.box}>
                    <p style={styles.p}>
                        Need help with Krionex, your account, billing, subscription, contract deployment, token dashboard, or wallet-related workflow?
                    </p>
                </div>
                <div style={styles.document}>
                    <h2 style={styles.h2}>Support Email</h2>
                    <p style={styles.p}>
                        Email us at{" "}
                        <a style={styles.link} href="mailto:support@krionex.com">
                            support@krionex.com
                        </a>
                        .
                    </p>

                    <h2 style={styles.h2}>What to Include</h2>
                    <p style={styles.p}>
                        To help us respond faster, please include relevant details such as:
                    </p>
                    <ul style={styles.ul}>
                        <li>your Krionex account email;</li>
                        <li>your wallet address, if the issue is wallet or deployment related;</li>
                        <li>the blockchain network used;</li>
                        <li>contract address or transaction hash, if applicable;</li>
                        <li>screenshots or error messages;</li>
                        <li>billing invoice or subscription reference, if the issue is payment related.</li>
                    </ul>

                    <h2 style={styles.h2}>Billing and Refunds</h2>
                    <p style={styles.p}>
                        For billing, subscription, cancellation, or refund questions, contact{" "}
                        <a style={styles.link} href="mailto:support@krionex.com">
                            support@krionex.com
                        </a>
                        . Refund requests are reviewed according to our Refund & Cancellation
                        Policy.
                    </p>

                    <h2 style={styles.h2}>Security Reports</h2>
                    <p style={styles.p}>
                        If you believe you have found a security issue, please report it
                        responsibly to{" "}
                        <a style={styles.link} href="mailto:support@krionex.com">
                            support@krionex.com
                        </a>
                        .
                    </p>

                    <h2 style={styles.h2}>Important Notes</h2>
                    <p style={styles.p}>
                        Krionex does not control blockchain networks, wallets, private keys,
                        gas fees, or irreversible on-chain transactions. We cannot recover
                        lost private keys, reverse confirmed blockchain transactions, or
                        refund blockchain network fees.
                    </p>
                </div>
            </section>
        </main>
    );
}